<template>
  <v-card
    class="tooltip-container"
    :class="{ 'tooltip-hidden': hideTooltip }"
    :style="{ transform: translate }"
    raised
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
  >
    <v-card-text>
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    position: {
      type: Array,
      default: () => [9999, 9999]
    }
  },
  data: () => ({
    top: 9999,
    left: 9999,
    pointerOnTooltip: false
  }),
  watch: {
    position: {
      handler() {
        this.positionTooltip();
      },
      immediate: true
    }
  },
  computed: {
    translate() {
      return `translate(${this.left}px,${this.top}px)`;
    },
    hideTooltip() {
      return !this.show && !this.pointerOnTooltip;
    }
  },
  methods: {
    positionTooltip() {
      this.$nextTick(() => {
        const padding = 8;
        const { width, height } = this.$el.getBoundingClientRect();
        let [left, top] = this.position;
        if (left + width > window.innerWidth - padding) {
          left = window.innerWidth - width - padding;
        }
        if (top + height > window.innerHeight - padding) {
          top = window.innerHeight - height - padding;
        }
        this.top = top;
        this.left = left;
      });
    },
    mouseenter() {
      this.pointerOnTooltip = true;
      this.$emit("mouseenter");
    },
    mouseleave() {
      this.pointerOnTooltip = false;
      this.$emit("mouseleave");
    }
  }
};
</script>

<style scoped>
.tooltip-container {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  overflow-y: auto;
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s linear;
  max-height: calc(100vh - 24px);
  max-width: 600px;
}

.tooltip-container.tooltip-hidden {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 0.15s, opacity 0.15s linear;
}
</style>
